import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Alert, Radio } from 'antd';

import LoadingFullContainerContent from 'Components/commonComponents/LoadingFullContainerContent';
import { SmallInsuranceCard } from 'Pages/QuotationsComparatorPage/components/InsurancePackageCard';

import Form from './Form';


const ModalGenerateSolicitudView = (props) => {
  const {
    visible,
    loading,
    messageError,

    selectedPackage,
    packages,
    sedes,
    vendedores,

    onCloseModal,
    handleSendModal,
    handleChangeSelectedPackage,

    form,
  } = props;

  return (
    <Modal
      width="60%"
      title={<p style={{ textAlign: 'center' }}>Generar solicitud de expedición</p>}
      visible={visible}
      onOk={handleSendModal}
      onCancel={onCloseModal}
      cancelText="Cancelar"
      okText="Generar solicitud expedición"
      cancelButtonProps={{ loading }}
      okButtonProps={{ loading }}
    >
      {messageError && <Alert message={messageError} type="error" style={{ marginBottom: '20px' }} />}
      <Radio.Group onChange={handleChangeSelectedPackage} value={selectedPackage ? selectedPackage.id : null} style={{ display: 'flex', justifyContent: 'center' }}>
        {packages.map((pacakge) => (
          <div
            key={pacakge.id}
            style={{
              textAlign: 'center',
              // boxShadow: stateQuotation.pacakge && stateQuotation.pacakge.id === pacakge.id ? '-4px 4px 12px 1px #d2d2d2' : 'none',
              margin: '0 10px',
            }}
          >
            <Radio value={pacakge.id} disabled={loading}>
              <SmallInsuranceCard
                insurancePackage={pacakge}
                onClose={false}
                insuranceCarrier={pacakge.insuranceCarrierFiltered}
                style={{ height: '180px', marginTop: '6px' }}
              />
            </Radio>
          </div>
        ))}
      </Radio.Group>
      {loading && <LoadingFullContainerContent />}
      {selectedPackage && <Form formikControl={form} sedes={sedes} vendedores={vendedores} />}
    </Modal>
  );
};

ModalGenerateSolicitudView.defaultProps = {
  visible: false,
  loading: false,
  messageError: null,

  packages: [],
  selectedPackage: null,
  sedes: [],
  vendedores: [],

  handleSendModal: () => {},
  onCloseModal: () => {},
  handleChangeSelectedPackage: () => {},
};

ModalGenerateSolicitudView.propTypes = {
  visible: PropTypes.bool,
  loading: PropTypes.bool,
  messageError: PropTypes.string,
  form: PropTypes.any.isRequired,

  packages: PropTypes.array,
  selectedPackage: PropTypes.shape({
    id: PropTypes.string,
  }),
  sedes: PropTypes.array,
  vendedores: PropTypes.array,

  handleSendModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  handleChangeSelectedPackage: PropTypes.func,
};

export default ModalGenerateSolicitudView;
